import { render, staticRenderFns } from "./task-priority.vue?vue&type=template&id=a44d494a&"
import script from "./task-priority.vue?vue&type=script&lang=js&"
export * from "./task-priority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports